import Icon from '@/components/ui/AppIcon';

interface Milestone {
  phase: string;
  month: string;
  title: string;
  description: string;
}

interface TimelineVisualizationProps {
  milestones: Milestone[];
}

const TimelineVisualization = ({ milestones }: TimelineVisualizationProps) => {
  return (
    <div className="bg-card border border-border rounded-lg p-8 institutional-shadow">
      <div className="flex items-center justify-between mb-8">
        <h3 className="text-2xl font-semibold text-text-primary">Typical Engagement Timeline</h3>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="CalendarIcon" size={20} variant="outline" />
          <span className="font-medium">6-12 Months Duration</span>
        </div>
      </div>

      {/* Desktop Timeline */}
      <div className="hidden lg:block">
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute top-8 left-0 right-0 h-1 bg-institutional/20"></div>
          <div className="absolute top-8 left-0 h-1 bg-institutional transition-all duration-1000" style={{ width: '100%' }}></div>

          {/* Milestones */}
          <div className="relative grid grid-cols-4 gap-4">
            {milestones.map((milestone, index) => (
              <div key={index} className="relative">
                {/* Milestone Marker */}
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-institutional rounded-full flex items-center justify-center text-institutional-foreground font-bold text-lg border-4 border-background shadow-lg">
                    {index + 1}
                  </div>
                </div>

                {/* Milestone Content */}
                <div className="bg-surface border border-border rounded-lg p-4 text-center">
                  <p className="text-xs font-semibold text-institutional mb-1">{milestone.phase}</p>
                  <p className="text-xs text-text-secondary mb-2">{milestone.month}</p>
                  <h4 className="text-sm font-semibold text-text-primary mb-2">{milestone.title}</h4>
                  <p className="text-xs text-text-secondary">{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Timeline */}
      <div className="lg:hidden space-y-6">
        {milestones.map((milestone, index) => (
          <div key={index} className="relative pl-12">
            {/* Vertical Line */}
            {index < milestones.length - 1 && (
              <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-institutional/20"></div>
            )}

            {/* Milestone Marker */}
            <div className="absolute left-0 top-0 w-12 h-12 bg-institutional rounded-full flex items-center justify-center text-institutional-foreground font-bold border-4 border-background shadow-lg">
              {index + 1}
            </div>

            {/* Milestone Content */}
            <div className="bg-surface border border-border rounded-lg p-4">
              <p className="text-xs font-semibold text-institutional mb-1">{milestone.phase}</p>
              <p className="text-xs text-text-secondary mb-2">{milestone.month}</p>
              <h4 className="text-sm font-semibold text-text-primary mb-2">{milestone.title}</h4>
              <p className="text-xs text-text-secondary">{milestone.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimelineVisualization;